import React, { useEffect, useState } from "react";

interface VidyardPlayerProps {
  uuid: string;
  type?: "inline" | "lightbox";
}

// Declare VidyardV4 type globally
declare global {
  interface Window {
    VidyardV4?: {
      api: {
        renderDOMPlayers: () => void;
      };
    };
  }
}

const VidyardPlayer: React.FC<VidyardPlayerProps> = ({ uuid, type = "inline" }) => {
  const [loaded, setLoaded] = useState(false);
  const scriptId = "vidyard-embed-script";

  useEffect(() => {
    const checkVidyardAPI = (attempt = 1) => {
      if (window.VidyardV4?.api) {
        window.VidyardV4.api.renderDOMPlayers();
        setLoaded(true);
      } else if (attempt < 5) {
        setTimeout(() => checkVidyardAPI(attempt + 1), 500);
      } else {
        console.error("Vidyard API failed to load after multiple attempts.");
      }
    };

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://play.vidyard.com/embed/v4.js";
      script.async = true;
      script.onload = () => {
        setTimeout(() => checkVidyardAPI(), 500);
      };
      script.onerror = () => {
        console.error("Failed to load Vidyard script.");
      };
      document.body.appendChild(script);
    } else {
      console.log("Vidyard script already present, checking API...");
      setTimeout(() => checkVidyardAPI(), 500);
    }
  }, []);

  return (
    <div className="vidyard-player video has-play-btn g-0 px-1">
      <div className="video-container">
        <div
          className="vidyard-player-embed"
          data-uuid={uuid}
          data-v="4"
          data-type={type}
          {...(type === "lightbox" ? { "data-lightbox": "true" } : {})}
        ></div>
      </div>
    </div>
  );
};

export default VidyardPlayer;
